<script setup lang="ts">
import { computed } from 'vue'
import CustomDivider from '@/components/createdUi/CustomDivider.vue'
import CollapsibleText from '@/components/createdUi/CollapsibleText.vue'

export interface IEntityFormSummaryItem {
  label: string
  value?: string | null
  collapsible?: boolean
}

const props = withDefaults(
  defineProps<{
    items: IEntityFormSummaryItem[]
    showDivider?: boolean
  }>(),
  {
    showDivider: false,
  },
)

const visibleItems = computed(() =>
  props.items.filter(item => String(item.value ?? '').trim() !== ''),
)
</script>

<template>
  <div v-if="visibleItems.length" class="d-flex flex-column ga-6">
    <CustomDivider v-if="showDivider" />

    <div class="d-flex flex-column ga-4">
      <div
        v-for="(item, index) in visibleItems"
        :key="`${item.label}-${index}`"
        class="d-flex flex-column ga-1"
      >
        <span class="text-body-1 entity-form-summary__label">
          {{ item.label }}
        </span>
        <CollapsibleText
          v-if="item.collapsible"
          :text="item.value"
          class="text-body-1 entity-form-summary__value"
        />
        <span
          v-else
          class="text-body-1 entity-form-summary__value"
        >
          {{ item.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.entity-form-summary__label {
  color: rgba(var(--v-theme-text-primary), var(--v-high-emphasis-opacity));
  font-weight: 500;
}

.entity-form-summary__value {
  color: rgba(var(--v-theme-text-primary), var(--v-medium-emphasis-opacity));
  font-weight: 400;
  word-break: break-word;
  white-space: pre-wrap;
}
</style>
